import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { ReactNode, useEffect, useState } from 'react';
import ScrollableTable from '../ScrollableTable';
import EcoImg from 'eco-design/base/eco-img';
import EcoButton from 'eco-design/base/eco-button';
import MobileTable from '../MobileTable';
import { getSolarRecommand2 } from '@/service/solar-calculator';

interface CompatibilityItem {
    category: string;
    image: string;
    products: string[];
    compatible: boolean;
    outlets: string;
    accessories: string[];
}

interface TableRow<T> {
    header: string;
    renderCell: (item: T) => ReactNode;
}

const CompatibilityTable: React.FC<{
    data: CompatibilityItem[];
    rows: TableRow<CompatibilityItem>[];
    mobileTableData: any;
    alsoLike: any;
    showAlsoLike?: boolean;
}> = ({ data, rows, mobileTableData, alsoLike, showAlsoLike = true }) => {
    const { locale } = getLocal();
    const { t } = useLang('CompatibilityTable');

    const [itemInfo, setItemInfo] = useState<any>(alsoLike[locale]);
    async function getItemInfo() {
        // const variantIds = tabs.map((tab) => tab.items.map((item) => item.variantId));

        const res = await getSolarRecommand2({ variantIds: [alsoLike[locale].variantId] }, locale);
        if (res.code === '0') {
            console.log(res.data[0]);
            if (res.data[0]) {
                setItemInfo({
                    ...alsoLike[locale],
                    img: res.data[0].variantImg,
                    title: res.data[0].productTitle,
                });
            }
        }
    }
    useEffect(() => {
        getItemInfo();
    }, []);

    return (
        <div className={styles.CompatibilityTable}>
            <div className="titleSection">
                <h2 className="title">{t('title')}</h2>
            </div>
            <div className="mobile-table">
                <MobileTable data={mobileTableData} />
            </div>
            <div className="pc-table">
                <ScrollableTable data={data} rows={rows} />
            </div>
            {showAlsoLike && (
                <div className="also-like">
                    <h2 className="title">{t('also_like_title')}</h2>
                    <div className="recommend-products">
                        <div className="product-item">
                            <div className="product-image">
                                <EcoImg pc={itemInfo.img} />
                            </div>
                            <div className="product-name">
                                <h3>{itemInfo.title}</h3>
                            </div>

                            <EcoButton lTheme="black" lType="filled" lRadius="ellipse" onClick={() => window.open(itemInfo.buy_link, '_blank')}>
                                {t('also_like_buy')}
                            </EcoButton>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CompatibilityTable;
